import React, { useState } from 'react';
import Login from '../../components/auth/Login/Login';
import Signup from '../../components/auth/Signup/Signup';
import './Auth.css';

const Auth = () => {
  const [isLoginMode, setIsLoginMode] = useState(true);

  const toggleMode = () => {
    setIsLoginMode(!isLoginMode);
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-left">
          <div className="auth-brand">
            <h1>Viral Trade</h1>
            <p>Your gateway to intelligent trading</p>
          </div>
          <div className="auth-features">
            <div className="feature">
              <div className="feature-icon">📊</div>
              <div className="feature-content">
                <h3>Advanced Analytics</h3>
                <p>Get deep insights with our powerful analysis tools</p>
              </div>
            </div>
            <div className="feature">
              <div className="feature-icon">🤖</div>
              <div className="feature-content">
                <h3>AI-Powered Chat</h3>
                <p>Ask questions and get intelligent trading advice</p>
              </div>
            </div>
            <div className="feature">
              <div className="feature-icon">📈</div>
              <div className="feature-content">
                <h3>Real-time Data</h3>
                <p>Stay updated with live market data and trends</p>
              </div>
            </div>
          </div>
        </div>
        <div className="auth-right">
          <div className="auth-form-container">
            {isLoginMode ? (
              <Login onToggleMode={toggleMode} />
            ) : (
              <Signup onToggleMode={toggleMode} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
